export default function(sectionId) {
  setTimeout(function() {
    var d = document.getElementById(sectionId);
    var topPos = d.offsetTop;
    window.scrollTo({ top: topPos, behavior: "smooth" });
  }, 1000);
}
